<template>
  <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <!--            <img src="Image/Container%20(1).png" class="d-block w-100" alt="...">-->
        <div class="carousel-caption ">
          <h2>Product List</h2>
          <p>Reliable - Durable - Flexible</p>
          <a href="">Show more

            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M1 11L11 1M11 1V11M11 1H1" stroke="url(#paint0_linear_204_400)" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
              <defs>
                <linearGradient id="paint0_linear_204_400" x1="6" y1="1" x2="6" y2="110.5"
                                gradientUnits="userSpaceOnUse">
                  <stop stop-color="white"/>
                  <stop offset="0.471976" stop-color="#0C1711"/>
                </linearGradient>
              </defs>
            </svg>
          </a>
        </div>
      </div>

    </div>
  </div>

  <div class="container my-4">
    <!-- Breadcrumb -->
    <nav aria-label="breadcrumb " class="d-none d-lg-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item d-flex align-items-center gap-2">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item"><a href="#">Products</a></li>
      </ol>
    </nav>

    <div class="row">
      <!-- Sidebar Filter -->
      <aside class="col-lg-4 z-0">
        <div class="left_bar">
          <div class="filter d-flex justify-content-between">
            <div class="d-flex align-items-center d-none d-lg-block" style="gap: 8px">
              <svg class="d-block d-lg-none" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                   viewBox="0 0 14 14" fill="none">
                <path
                    d="M1.66666 1.09375H12.3332C12.7014 1.09375 12.9999 1.39217 12.9999 1.76032L13 2.81752C13.0001 2.99437 12.9298 3.16397 12.8047 3.28901L8.52847 7.56505C8.40347 7.69004 8.33321 7.85964 8.33321 8.03644V12.2397C8.33321 12.6734 7.92561 12.9917 7.50489 12.8865L6.17158 12.5532C5.87478 12.479 5.66659 12.2123 5.66659 11.9064V8.03644C5.66659 7.85964 5.59635 7.69004 5.47133 7.56505L1.19526 3.28897C1.07023 3.16396 1 2.99439 1 2.81758V1.76041C1 1.39223 1.29847 1.09375 1.66666 1.09375Z"
                    stroke="#3C3C3D" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <h5 class="d-none">Filter</h5>
            </div>
            <div class="d-block d-lg-none">
              <a class="text-decoration-none " data-bs-toggle="offcanvas" href="#offcanvasExample" role="button"
                 aria-controls="offcanvasExample" @click="toggleOffCanvas">
                <div class="d-flex align-items-center" style="gap: 8px">
                  <svg class="d-block d-lg-none" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                       viewBox="0 0 14 14" fill="none">
                    <path
                        d="M1.66666 1.09375H12.3332C12.7014 1.09375 12.9999 1.39217 12.9999 1.76032L13 2.81752C13.0001 2.99437 12.9298 3.16397 12.8047 3.28901L8.52847 7.56505C8.40347 7.69004 8.33321 7.85964 8.33321 8.03644V12.2397C8.33321 12.6734 7.92561 12.9917 7.50489 12.8865L6.17158 12.5532C5.87478 12.479 5.66659 12.2123 5.66659 11.9064V8.03644C5.66659 7.85964 5.59635 7.69004 5.47133 7.56505L1.19526 3.28897C1.07023 3.16396 1 2.99439 1 2.81758V1.76041C1 1.39223 1.29847 1.09375 1.66666 1.09375Z"
                        stroke="#3C3C3D" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <h5 class="d-none">Filter</h5>
                </div>
              </a>


              <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample"
                   aria-labelledby="offcanvasExampleLabel">
                <div class="offcanvas-header">
                  <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body">
                  <div class="bar_">
                    <div class="accordion " id="accordionExample2">
                      <div class="d-flex gap-2 justify-content-between" style="margin-bottom: 16px">
                        <div class="d-flex gap-2 product_list" >
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"
                               fill="none">
                            <path
                                d="M1 17C1 15.46 1 14.69 1.347 14.124C1.541 13.807 1.807 13.541 2.124 13.347C2.689 13 3.46 13 5 13C6.54 13 7.31 13 7.876 13.347C8.193 13.541 8.459 13.807 8.653 14.124C9 14.689 9 15.46 9 17C9 18.54 9 19.31 8.653 19.877C8.459 20.193 8.193 20.459 7.876 20.653C7.311 21 6.54 21 5 21C3.46 21 2.69 21 2.124 20.653C1.80735 20.4593 1.54108 20.1934 1.347 19.877C1 19.31 1 18.54 1 17ZM13 17C13 15.46 13 14.69 13.347 14.124C13.541 13.807 13.807 13.541 14.124 13.347C14.689 13 15.46 13 17 13C18.54 13 19.31 13 19.877 13.347C20.193 13.541 20.459 13.807 20.653 14.124C21 14.689 21 15.46 21 17C21 18.54 21 19.31 20.653 19.877C20.4589 20.1931 20.1931 20.4589 19.877 20.653C19.31 21 18.54 21 17 21C15.46 21 14.69 21 14.124 20.653C13.8073 20.4593 13.5411 20.1934 13.347 19.877C13 19.31 13 18.54 13 17ZM1 5C1 3.46 1 2.69 1.347 2.124C1.541 1.807 1.807 1.541 2.124 1.347C2.689 1 3.46 1 5 1C6.54 1 7.31 1 7.876 1.347C8.193 1.541 8.459 1.807 8.653 2.124C9 2.689 9 3.46 9 5C9 6.54 9 7.31 8.653 7.876C8.459 8.193 8.193 8.459 7.876 8.653C7.311 9 6.54 9 5 9C3.46 9 2.69 9 2.124 8.653C1.80724 8.45904 1.54096 8.19277 1.347 7.876C1 7.311 1 6.54 1 5ZM13 5C13 3.46 13 2.69 13.347 2.124C13.541 1.807 13.807 1.541 14.124 1.347C14.689 1 15.46 1 17 1C18.54 1 19.31 1 19.877 1.347C20.193 1.541 20.459 1.807 20.653 2.124C21 2.689 21 3.46 21 5C21 6.54 21 7.31 20.653 7.876C20.459 8.193 20.193 8.459 19.877 8.653C19.31 9 18.54 9 17 9C15.46 9 14.69 9 14.124 8.653C13.8072 8.45904 13.541 8.19277 13.347 7.876C13 7.311 13 6.54 13 5Z"
                                stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <h6>We <strong>Offer</strong></h6>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                      </div>

                      <!-- Dynamic Category and Subcategory Filter -->
                      <div v-for="category in categoriesData" :key="category.id" class="accordion-item">
                        <h2 class="accordion-header">
                          <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                  :class="{ collapsed: !isCategoryOpen(category.id) }"
                                  :data-bs-target="'#collapse' + category.id"
                                  :aria-expanded="isCategoryOpen(category.id)">
                            {{ category.title }} <span class="badge__ ms-auto">{{ countProducts(category.id) }}</span>
                          </button>
                        </h2>
                        <div :id="'collapse' + category.id" class="accordion-collapse collapse"
                             :class="{ show: isCategoryOpen(category.id) }">
                          <div class="accordion-body">
                            <ul class="list-group list-group-flush">
                              <li v-for="subcategory in category.subcategories" :key="subcategory.id"
                                  class="list-group-item">
                                <a href="#" @click.prevent="selectCategory(category.id, subcategory.id)">
                                  {{ subcategory.name }} <span class="badge__">{{
                                    getFilteredProducts(category.id).filter(product => product.subcategory.id === subcategory.id).length
                                  }}</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mb-3 ">
                      <div class="d-flex product_list gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path
                              d="M10 12.3571L11.8095 13.4524C11.9841 13.5635 12.1587 13.5597 12.3333 13.441C12.5079 13.3222 12.5714 13.1594 12.5238 12.9524L12.0476 10.881L13.6667 9.47619C13.8254 9.33333 13.873 9.16286 13.8095 8.96476C13.746 8.76667 13.6032 8.65936 13.381 8.64286L11.2619 8.47619L10.4286 6.52381C10.3492 6.33333 10.2063 6.2381 10 6.2381C9.79365 6.2381 9.65079 6.33333 9.57143 6.52381L8.7381 8.47619L6.61905 8.64286C6.39683 8.65873 6.25397 8.76603 6.19048 8.96476C6.12698 9.16349 6.1746 9.33397 6.33333 9.47619L7.95238 10.881L7.47619 12.9524C7.42857 13.1587 7.49206 13.3216 7.66667 13.441C7.84127 13.5603 8.01587 13.5641 8.19048 13.4524L10 12.3571ZM6.80952 17.619H4.28571C3.7619 17.619 3.31365 17.4327 2.94095 17.06C2.56825 16.6873 2.38159 16.2387 2.38095 15.7143V13.1905L0.547619 11.3333C0.373016 11.1429 0.238095 10.9327 0.142857 10.7029C0.047619 10.473 0 10.2387 0 10C0 9.76127 0.047619 9.5273 0.142857 9.29809C0.238095 9.06889 0.373016 8.85841 0.547619 8.66667L2.38095 6.80952V4.28571C2.38095 3.7619 2.56762 3.31365 2.94095 2.94095C3.31429 2.56825 3.76254 2.38159 4.28571 2.38095H6.80952L8.66667 0.547619C8.85714 0.373016 9.06762 0.238095 9.29809 0.142857C9.52857 0.047619 9.76254 0 10 0C10.2375 0 10.4717 0.047619 10.7029 0.142857C10.934 0.238095 11.1441 0.373016 11.3333 0.547619L13.1905 2.38095H15.7143C16.2381 2.38095 16.6867 2.56762 17.06 2.94095C17.4333 3.31429 17.6197 3.76254 17.619 4.28571V6.80952L19.4524 8.66667C19.627 8.85714 19.7619 9.06762 19.8571 9.29809C19.9524 9.52857 20 9.76254 20 10C20 10.2375 19.9524 10.4717 19.8571 10.7029C19.7619 10.934 19.627 11.1441 19.4524 11.3333L17.619 13.1905V15.7143C17.619 16.2381 17.4327 16.6867 17.06 17.06C16.6873 17.4333 16.2387 17.6197 15.7143 17.619H13.1905L11.3333 19.4524C11.1429 19.627 10.9327 19.7619 10.7029 19.8571C10.473 19.9524 10.2387 20 10 20C9.76127 20 9.5273 19.9524 9.29809 19.8571C9.06889 19.7619 8.85841 19.627 8.66667 19.4524L6.80952 17.619ZM7.61905 15.7143L10 18.0952L12.381 15.7143H15.7143V12.381L18.0952 10L15.7143 7.61905V4.28571H12.381L10 1.90476L7.61905 4.28571H4.28571V7.61905L1.90476 10L4.28571 12.381V15.7143H7.61905Z"
                              fill="black"/>
                        </svg>
                        <h6>Quality</h6>
                      </div>
                      <div class="d-flex flex-column" style="padding: 20px; background: white; gap: 20px">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="4k_">
                          <label class="form-check-label" for="4k_">Cat6</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="hd_">
                          <label class="form-check-label" for="hd_">Cat6A</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="metal_">
                          <label class="form-check-label" for="metal_">Cat7</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="cat8_">
                          <label class="form-check-label" for="cat8_">Cat8</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="single_mode_">
                          <label class="form-check-label" for="single_mode_">Single Mode</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="Multi_mode_">
                          <label class="form-check-label" for="Multi_mode_">Multi Mode</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="Amp12_">
                          <label class="form-check-label" for="Amp12_">13 Amp</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="amp13_">
                          <label class="form-check-label" for="amp13_">16 Amp</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="amp32_">
                          <label class="form-check-label" for="amp32_">32 Amp</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="amp64_">
                          <label class="form-check-label" for="amp64_">64 Amp</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="wall_mount_">
                          <label class="form-check-label" for="wall_mount_">Wall Mount Cabinet</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="Floor_stand_">
                          <label class="form-check-label" for="Floor_stand_">Floor Stand Cabinet</label>
                        </div>
                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>


            <button class="clear_btn" @click="clearFilters">Clear All</button>
          </div>


          <div class="accordion d-none d-lg-block" id="accordionExample">
            <div class="d-flex gap-2 product_list" style="margin-bottom: 16px">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path
                    d="M1 17C1 15.46 1 14.69 1.347 14.124C1.541 13.807 1.807 13.541 2.124 13.347C2.689 13 3.46 13 5 13C6.54 13 7.31 13 7.876 13.347C8.193 13.541 8.459 13.807 8.653 14.124C9 14.689 9 15.46 9 17C9 18.54 9 19.31 8.653 19.877C8.459 20.193 8.193 20.459 7.876 20.653C7.311 21 6.54 21 5 21C3.46 21 2.69 21 2.124 20.653C1.80735 20.4593 1.54108 20.1934 1.347 19.877C1 19.31 1 18.54 1 17ZM13 17C13 15.46 13 14.69 13.347 14.124C13.541 13.807 13.807 13.541 14.124 13.347C14.689 13 15.46 13 17 13C18.54 13 19.31 13 19.877 13.347C20.193 13.541 20.459 13.807 20.653 14.124C21 14.689 21 15.46 21 17C21 18.54 21 19.31 20.653 19.877C20.4589 20.1931 20.1931 20.4589 19.877 20.653C19.31 21 18.54 21 17 21C15.46 21 14.69 21 14.124 20.653C13.8073 20.4593 13.5411 20.1934 13.347 19.877C13 19.31 13 18.54 13 17ZM1 5C1 3.46 1 2.69 1.347 2.124C1.541 1.807 1.807 1.541 2.124 1.347C2.689 1 3.46 1 5 1C6.54 1 7.31 1 7.876 1.347C8.193 1.541 8.459 1.807 8.653 2.124C9 2.689 9 3.46 9 5C9 6.54 9 7.31 8.653 7.876C8.459 8.193 8.193 8.459 7.876 8.653C7.311 9 6.54 9 5 9C3.46 9 2.69 9 2.124 8.653C1.80724 8.45904 1.54096 8.19277 1.347 7.876C1 7.311 1 6.54 1 5ZM13 5C13 3.46 13 2.69 13.347 2.124C13.541 1.807 13.807 1.541 14.124 1.347C14.689 1 15.46 1 17 1C18.54 1 19.31 1 19.877 1.347C20.193 1.541 20.459 1.807 20.653 2.124C21 2.689 21 3.46 21 5C21 6.54 21 7.31 20.653 7.876C20.459 8.193 20.193 8.459 19.877 8.653C19.31 9 18.54 9 17 9C15.46 9 14.69 9 14.124 8.653C13.8072 8.45904 13.541 8.19277 13.347 7.876C13 7.311 13 6.54 13 5Z"
                    stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <h6>We <strong>Offer</strong></h6>
            </div>

            <!-- Dynamic Category and Subcategory Filter -->
            <div v-for="category in categoriesData" :key="category.id" class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        :class="{ collapsed: !isCategoryOpen(category.id) }" @click="selectCategory(category.id)"
                        :data-bs-target="'#collapse' + category.id" :aria-expanded="isCategoryOpen(category.id)">
                  {{ category.title }} <span class="badge__ ms-auto">{{ countProducts(category.id) }}</span>
                </button>
              </h2>
              <div :id="'collapse' + category.id" class="accordion-collapse collapse"
                   :class="{ show: isCategoryOpen(category.id) }">
                <div class="accordion-body">
                  <ul class="list-group list-group-flush">
                    <li v-for="subcategory in category.subcategories" :key="subcategory.id"
                        class="list-group-item">
                      <a href="#" @click.prevent="selectCategory(category.id, subcategory.id)">
                        {{ subcategory.name }} <span class="badge__">{{
                          countSubcategoryProducts(subcategory.id)
                        }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-3 d-none d-lg-block">
            <div class="d-flex product_list gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                    d="M10 12.3571L11.8095 13.4524C11.9841 13.5635 12.1587 13.5597 12.3333 13.441C12.5079 13.3222 12.5714 13.1594 12.5238 12.9524L12.0476 10.881L13.6667 9.47619C13.8254 9.33333 13.873 9.16286 13.8095 8.96476C13.746 8.76667 13.6032 8.65936 13.381 8.64286L11.2619 8.47619L10.4286 6.52381C10.3492 6.33333 10.2063 6.2381 10 6.2381C9.79365 6.2381 9.65079 6.33333 9.57143 6.52381L8.7381 8.47619L6.61905 8.64286C6.39683 8.65873 6.25397 8.76603 6.19048 8.96476C6.12698 9.16349 6.1746 9.33397 6.33333 9.47619L7.95238 10.881L7.47619 12.9524C7.42857 13.1587 7.49206 13.3216 7.66667 13.441C7.84127 13.5603 8.01587 13.5641 8.19048 13.4524L10 12.3571ZM6.80952 17.619H4.28571C3.7619 17.619 3.31365 17.4327 2.94095 17.06C2.56825 16.6873 2.38159 16.2387 2.38095 15.7143V13.1905L0.547619 11.3333C0.373016 11.1429 0.238095 10.9327 0.142857 10.7029C0.047619 10.473 0 10.2387 0 10C0 9.76127 0.047619 9.5273 0.142857 9.29809C0.238095 9.06889 0.373016 8.85841 0.547619 8.66667L2.38095 6.80952V4.28571C2.38095 3.7619 2.56762 3.31365 2.94095 2.94095C3.31429 2.56825 3.76254 2.38159 4.28571 2.38095H6.80952L8.66667 0.547619C8.85714 0.373016 9.06762 0.238095 9.29809 0.142857C9.52857 0.047619 9.76254 0 10 0C10.2375 0 10.4717 0.047619 10.7029 0.142857C10.934 0.238095 11.1441 0.373016 11.3333 0.547619L13.1905 2.38095H15.7143C16.2381 2.38095 16.6867 2.56762 17.06 2.94095C17.4333 3.31429 17.6197 3.76254 17.619 4.28571V6.80952L19.4524 8.66667C19.627 8.85714 19.7619 9.06762 19.8571 9.29809C19.9524 9.52857 20 9.76254 20 10C20 10.2375 19.9524 10.4717 19.8571 10.7029C19.7619 10.934 19.627 11.1441 19.4524 11.3333L17.619 13.1905V15.7143C17.619 16.2381 17.4327 16.6867 17.06 17.06C16.6873 17.4333 16.2387 17.6197 15.7143 17.619H13.1905L11.3333 19.4524C11.1429 19.627 10.9327 19.7619 10.7029 19.8571C10.473 19.9524 10.2387 20 10 20C9.76127 20 9.5273 19.9524 9.29809 19.8571C9.06889 19.7619 8.85841 19.627 8.66667 19.4524L6.80952 17.619ZM7.61905 15.7143L10 18.0952L12.381 15.7143H15.7143V12.381L18.0952 10L15.7143 7.61905V4.28571H12.381L10 1.90476L7.61905 4.28571H4.28571V7.61905L1.90476 10L4.28571 12.381V15.7143H7.61905Z"
                    fill="black"/>
              </svg>
              <h6>Filter</h6>
            </div>
            <div class="d-flex flex-column" style="padding: 20px; background: white; gap: 20px">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="4k">
                <label class="form-check-label" for="4k">Cat6</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="hd">
                <label class="form-check-label" for="hd">Cat6A</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="metal">
                <label class="form-check-label" for="metal">Cat7</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="cat8">
                <label class="form-check-label" for="cat8">Cat8</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="single_mode">
                <label class="form-check-label" for="single_mode">Single Mode</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="Multi_mode">
                <label class="form-check-label" for="Multi_mode">Multi Mode</label>
              </div>
<!--              <div class="form-check">-->
<!--                <input class="form-check-input" type="checkbox" id="Amp12">-->
<!--                <label class="form-check-label" for="Amp12">13 Amp</label>-->
<!--              </div>-->
<!--              <div class="form-check">-->
<!--                <input class="form-check-input" type="checkbox" id="amp13">-->
<!--                <label class="form-check-label" for="amp13">16 Amp</label>-->
<!--              </div>-->
<!--              <div class="form-check">-->
<!--                <input class="form-check-input" type="checkbox" id="amp32">-->
<!--                <label class="form-check-label" for="amp32">32 Amp</label>-->
<!--              </div>-->
<!--              <div class="form-check">-->
<!--                <input class="form-check-input" type="checkbox" id="amp64">-->
<!--                <label class="form-check-label" for="amp64">64 Amp</label>-->
<!--              </div>-->
<!--              <div class="form-check">-->
<!--                <input class="form-check-input" type="checkbox" id="wall_mount">-->
<!--                <label class="form-check-label" for="wall_mount">Wall Mount Cabinet</label>-->
<!--              </div>-->
<!--              <div class="form-check">-->
<!--                <input class="form-check-input" type="checkbox" id="Floor_stand">-->
<!--                <label class="form-check-label" for="Floor_stand">Floor Stand Cabinet</label>-->
<!--              </div>-->
            </div>


          </div>
        </div>
      </aside>

      <!-- Product Grid -->
      <main class="col-lg-8 top-margin-product" :style="{ zIndex: offcanvasVisible ? '-1' : '' }">
        <div class="product-grid">
          <div v-if="paginatedProducts.length === 0">No products found.</div>
          <div v-for="product in paginatedProducts" :key="product.id" class="card" @click="navigateToProductPage(product.slug)" style="cursor: pointer;">
            <a :href="`/product/${product.slug}`">
              <div class="card-image position-relative">
                      <span class="badge bg-warning position-absolute top-0 start-0 m-2"
                            v-if="product.status === 'POPULAR'">Popular</span>
                <img loading="lazy" :src="product.image" class="card-img-top" :alt="product.title">
              </div>
              <div class="card-body text-center">
                <h6 class="card-title">{{ product.title }}</h6>
              </div>
            </a>
          </div>
        </div>

        <!-- Pagination -->

        <div class="d-flex align-items-center" style="margin-top: 50px;">
          <div class="d-none d-lg-block">
            <div class="items-per-page ">
              <div class="dropdown">
                <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                  {{ itemsPerPage }}
                </a>
                <ul class="dropdown-menu">
                  <li v-for="item in [2, 10, 12, 20, 50, 100]" :key="item">
                    <a class="dropdown-item" href="#" @click.prevent="setItemsPerPage(item)">{{ item }}</a>
                  </li>
                </ul>
              </div>
              <span class="ms-2 per_page">Items per page</span>
            </div>
          </div>


          <nav aria-label="Page navigation" class="ms-auto">
            <ul class="pagination mb-0 d-flex" style="gap: 15px">
              <!-- Previous Button -->
              <li class="page-item">
                <a class="page-link Bor" href="#" aria-label="Previous" @click.prevent="prevPage"
                   :class="{ disabled: currentPage === 1 }">
                  <span aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                      <path d="M5 9.5L1 5.5L5 1.5" stroke="url(#paint0_linear_309_233)" stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"/>
                      <defs>
                        <linearGradient id="paint0_linear_309_233" x1="1" y1="5.49626" x2="5" y2="5.49625"
                                        gradientUnits="userSpaceOnUse">
                          <stop stop-color="#313131"/>
                          <stop offset="1" stop-color="#1E1E1E"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <span class="d-none d-md-block">Previous</span>

                  </span>
                </a>
              </li>

              <!-- Page Numbers -->
              <li v-for="page in visiblePages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                <a class="page-link" href="#" @click.prevent="goToPage(page)">
                  {{ page }}
                </a>
              </li>

              <!-- Next Button -->
              <li class="page-item">
                <a class="page-link Bor" href="#" aria-label="Next" @click.prevent="nextPage"
                   :class="{ disabled: currentPage === totalPages }">
                  <span aria-hidden="true">
                    <span class="d-none d-md-block">Next</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none">
                      <path d="M1.5 1.5L5.5 5.5L1.5 9.5" stroke="black" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                  </span>
                </a>
              </li>
            </ul>
          </nav>


        </div>
      </main>
    </div>
  </div>
</template>

<script>

export default {
  name: "AllProducts",
  props: ['products', 'categories'],
  data() {
    return {
      categoriesData: JSON.parse(this.categories),
      productsData: JSON.parse(this.products),
      selectedCategory: null,
      selectedSubcategory: null,
      currentPage: 1,
      itemsPerPage: 12,
      offcanvasVisible: false,
    };
  },
  computed: {
    filteredProducts() {
      let products = this.productsData;

      // Filter by category
      if (this.selectedCategory) {
        products = products.filter(product => product.subcategory.category.id === this.selectedCategory);
      }

      // Further filter by subcategory if selected
      if (this.selectedSubcategory) {
        products = products.filter(product => product.subcategory.id === this.selectedSubcategory);
      }

      return products;
    },
    paginatedProducts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredProducts.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredProducts.length / this.itemsPerPage);
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 5) {
        // Show all pages if total pages are 5 or less
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        // Show first 3, current, and last page with "..." in between
        if (current <= 3) {
          pages.push(1, 2, 3, "...", total);
        } else if (current >= total - 2) {
          pages.push(1, "...", total - 2, total - 1, total);
        } else {
          pages.push(1, "...", current - 1, current, current + 1, "...", total);
        }
      }

      return pages;
    }
  },
  mounted() {
    const selectedTitle = localStorage.getItem('selectedTitle');
    if (selectedTitle) {
      this.filterProductsUsingCategory(selectedTitle);
      localStorage.removeItem('selectedTitle');
    }
    this.eventBus.on('slideClicked', this.filterProductsUsingCategory);
    this.checkOffcanvas();
    document.querySelector('.offcanvas-start')?.addEventListener('shown.bs.offcanvas', this.checkOffcanvas);
    document.querySelector('.offcanvas-start')?.addEventListener('hidden.bs.offcanvas', this.checkOffcanvas);
  },
  methods: {
    toggleOffCanvas() {
      this.offcanvasVisible = true;
    },
    checkOffcanvas() {
      const offcanvas = document.querySelector('.offcanvas-start');
      // Check if the 'show' class is present on the offcanvas
      if (offcanvas.classList.contains('show')) {
        console.log();
      } else {
        this.offcanvasVisible = false;
      }
    },
    navigateToProductPage(productSlug) {
      window.location.href = `/product/${productSlug}`;
    },
    getFilteredProducts(categoryId) {
      return this.productsData.filter(product => product.categoryId === categoryId);
    },
    countProducts(categoryId) {
      // Count products under a specific category by checking nested category in subcategory
      return this.productsData.filter(product => product.subcategory.category.id === categoryId).length;
    },
    selectCategory(categoryId, subcategoryId = null) {
      // Filter by category and optionally by subcategory
      this.selectedCategory = categoryId;
      this.selectedSubcategory = subcategoryId;
      this.currentPage = 1;
    },
    countSubcategoryProducts(subcategoryId) {
      return this.productsData.filter(
        (product) => product.subcategory.id === subcategoryId).length;
    },
    selectSubcategory(subcategoryId) {
      this.selectedSubcategory = subcategoryId;
      this.currentPage = 1;
    },
    clearFilters() {
      this.selectedCategory = null;
      this.selectedSubcategory = null;
      this.currentPage = 1;
      this.updateURL();
    },
    setItemsPerPage(count) {
      this.itemsPerPage = count;
      this.currentPage = 1;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Smooth scrolling effect
      });
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
      this.scrollToTop();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
      this.scrollToTop();
    },
    goToPage(page) {
      if (page === "...") return; // Ignore clicks on "..."
      this.currentPage = page;
      this.scrollToTop();
    },
    updateURL() {
      const params = new URLSearchParams();
      if (this.selectedCategory) params.set("category", this.selectedCategory);
      if (this.selectedSubcategory) params.set("subcategory", this.selectedSubcategory);

      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState(null, null, newUrl);
    },
    applyFiltersFromURL() {
      const params = new URLSearchParams(window.location.search);
      const category = params.get("category");
      const subcategory = params.get("subcategory");

      if (category) this.selectedCategory = parseInt(category);
      if (subcategory) this.selectedSubcategory = parseInt(subcategory);
    },
    isCategoryOpen(categoryId) {
      return this.selectedCategory === categoryId;
    },
    filterProductsUsingCategory(title) {
      console.log('Title: ', title);
      const category = this.categoriesData.find(cat => cat.title === title);
      console.log('Category: ', category);
      this.selectCategory(category.id);
    }
  },
  created() {
    this.applyFiltersFromURL();
  },
  beforeUnmount() {
    this.eventBus.off('slideClicked', this.filterProductsUsingCategory);
  }
};
</script>

<style scoped>

@font-face {
  font-family: 'Poppins';
  src: url('../assets/Poppins/Poppins-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url('../assets/Poppins/Poppins-SemiBold.ttf') format('truetype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url('../assets/Poppins/Poppins-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}

a {
  text-decoration: none;
}

.Bor {
  border-radius: 6px !important;
  border: 1px solid #E2E2E2 !important;
  padding: 10px;
}

.page-link span {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
}

.per_page {
  color: #323232;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
}

.form-check-label {
  color: #1E1E1E;
  font-family:'Poppins', sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px; /* 100% */
  letter-spacing: 0.8px;
  text-transform: capitalize;
}

.carousel-caption {
  top: 30%;
}

.carousel-caption h2 {
  color: #FFF;
  text-align: center;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px; /* 120% */
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.carousel-caption p {
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px; /* 162.5% */
  margin-bottom: 40px;
}

.carousel-caption a {
  color: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px; /* 100% */
  padding: 13px 24px;
  text-decoration: none;
  border-radius: 40px;
  border: 2px solid #FFF;
  display: inline-block;
}


.breadcrumb {
  background: #F6F6F6;
  padding: 20px 80px;
}

.breadcrumb-item a {
  text-decoration: none;
  color: #1E1E1E;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 85.714% */
  letter-spacing: 0.5px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: '';

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border: solid #1E1E1E;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  margin-right: 0px;
  transform: rotate(-45deg);
  transition: transform 0.3s ease;
  height: 0;
  width: 0;
}

.clear_btn {
  color: #EC0101;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 100% */
  letter-spacing: 0.8px;
  text-transform: capitalize;
  border-radius: 6px;
  border: 1px solid rgba(236, 1, 1, 0.20);
  background: rgba(255, 238, 238, 0.50);
  padding: 13px 20px;
  cursor: pointer;
}

.color-option {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
}

.card {
  position: relative;
  border: none;
  pointer-events: auto;
}

.card img {
  max-height: 150px;
  object-fit: cover;
}

.badge {
  font-size: 0.8rem;
  padding: 0.3rem 0.5rem;
}


.left_bar {
  padding: 70px 20px;
  background: #F8F8F8;
  box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
  gap: 40px;
  display: flex;
  flex-direction: column;
}

.filter {
  padding-bottom: 16px;
  border-bottom: 1px solid #E1E1E1;
  align-items: center;

}

.filter h5 {
  color: #1E1E1E;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 83.333% */
  letter-spacing: 0.8px;
  margin-bottom: 0;
  text-transform: capitalize;
}

.clear_btn {
  color: #EC0101;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 100% */
  letter-spacing: 0.8px;
  text-transform: capitalize;
}
.product_list{
  margin-bottom: 16px;
}

.product_list h6 {
  color: #1E1E1E;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-style: normal;
  line-height: 20px; /* 111.111% */
  letter-spacing: 0.5px;
  text-transform: capitalize;
}

.accordion-button {
  color: #1E1E1E;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px; /* 100% */
  letter-spacing: 0.5px;
  text-transform: capitalize;
  display: flex;
  justify-content: flex-start;
}

.accordion-button::before {
  content: "";
  border: solid #1E1E1E;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  margin-right: 8px; /* Adds space between arrow and text */
  transform: rotate(-45deg);
  transition: transform 0.3s ease;
  height: 0;
  width: 0;
}

.accordion-button:not(.collapsed)::before {
  transform: rotate(45deg);
}

.accordion-button::after {
  content: none; /* Removes the default arrow icon after text */
}

.accordion-button:not(.collapsed) {
  color: black;
  background-color: white;
  box-shadow: none;
  outline: none;
}

.accordion-button:focus {
  z-index: 3;
  outline: none;
  box-shadow: none;
}

.badge__ {
  border-radius: 4px;
  background: rgba(190, 237, 242, 0.30);
  padding: 4px;
  color: #098BC2;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 12px; /* 100% */
  text-transform: capitalize;
}

.list-group-item {
  border: none;
}

.list-group-item a {
  color: #414141;
  font-family:'Poppins', sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px; /* 100% */
  letter-spacing: 0.5px;
  text-transform: capitalize;
  text-decoration: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.list-group {
  display: flex;
  gap: 12px;
}


.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(258px, 0fr));
  gap: 40px;
}

.card {
  position: relative;
  border: none;
}

.card-image {
  background: #FAFAFA;
  padding: 20px;
  position: relative;
}

.card-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.pagination .page-link {
  color: #000; /* Text color for page numbers */
  z-index: 0;
}

.pagination .page-item.active .page-link {
  background-color: #000; /* Background for active page */
  color: #fff; /* Text color for active page */
  border: none;
}

.items-per-page {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.items-per-page {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.dropdown-toggle {
  color: #000;
  text-decoration: none;
  font-weight: bold;
}

.page-link {
  border: 1px solid black ;
  border-radius: 50px ;
}

.card-title {
  color: #1E1E1E;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.5px;
  text-transform: capitalize;
  text-align: start;

}

.form-check-input:checked {
  background-color: #000000;
  border-color: #000000;
}


@media only screen and (max-width: 375px) {


  .offcanvas-body {
    background: #F8F8F8;
    box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
  }

  .bar_ {
    padding: 20px;
    gap: 40px;
    display: flex;
    flex-direction: column;
  }

  .img_one {
    display: block !important;
  }

  .product_item_area {
    padding: 20px 20px !important;
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
  }

  .carousel-caption h2 {
    color: #FFF;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 100% */
    letter-spacing: 0.8px;
    text-transform: uppercase;
  }

  .carousel-caption p {
    color: #FFF;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 14px; /* 100% */
    margin-bottom: 40px;
  }

  .carousel-caption a {
    color: #FFF;
    text-align: right;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px; /* 100% */
    padding: 13px 24px;
    text-decoration: none;
    border-radius: 40px;
    border: 2px solid #FFF;
    display: inline-block;
  }

  .filter h5 {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 100% */
    text-transform: capitalize;
  }

  .clear_btn {
    color: #EC0101;
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    line-height: 14px; /* 100% */
  }

  .left_bar {
    padding: 20px;
  }

}

@media only screen and (min-width: 376px) and (max-width: 425px) {
    .breadcrumb-item a {
  text-decoration: none;
  color: #1E1E1E;
  font-size: 12px;

}
  .breadcrumb {
    background: #F6F6F6;
    padding: 20px !important;
  }
    .breadcrumb-item.active {
    font-size: 12px;
  }
  .offcanvas-body {
    background: #F8F8F8;
    box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
  }

  .bar_ {
    padding: 20px;
    background: #F8F8F8;
    box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
    gap: 40px;
    display: flex;
    flex-direction: column;
  }

  .img_two {
    display: block !important;
  }

  .product_item_area {
    padding: 20px 20px !important;
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
  }

  .carousel-caption h2 {
    color: #FFF;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 100% */
    letter-spacing: 0.8px;
    text-transform: uppercase;
  }

  .carousel-caption p {
    color: #FFF;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 14px; /* 100% */
    margin-bottom: 40px;
  }

  .carousel-caption a {
    color: #FFF;
    text-align: right;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px; /* 100% */
    padding: 13px 24px;
    text-decoration: none;
    border-radius: 40px;
    border: 2px solid #FFF;
    display: inline-block;
  }

  .form-select {
    font-size: 0.8rem;
  }

  .filter h5 {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 100% */
    text-transform: capitalize;
  }

  .clear_btn {
    color: #EC0101;
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    line-height: 14px; /* 100% */
  }

  .left_bar {
    padding: 20px;
  }

}

@media only screen and (min-width: 426px) and (max-width: 767px) {
    .breadcrumb-item a {
  text-decoration: none;
  color: #1E1E1E;
  font-size: 12px;

}
  .breadcrumb {
    background: #F6F6F6;
    padding: 20px !important;
  }
  .offcanvas-body {
    background: #F8F8F8;
    box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
  }

  .bar_ {
    padding: 20px;
    background: #F8F8F8;
    box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
    gap: 40px;
    display: flex;
    flex-direction: column;
  }

  .img_three {
    display: block !important;
  }

  .form-select {
    font-size: 0.8rem;
  }

  .product_item_area {
    padding: 20px 20px !important;
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(191px, 1fr));
    gap: 20px;
  }

  .carousel-caption h2 {
    color: #FFF;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 100% */
    letter-spacing: 0.8px;
    text-transform: uppercase;
  }

  .carousel-caption p {
    color: #FFF;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 14px; /* 100% */
    margin-bottom: 40px;
  }

  .carousel-caption a {
    color: #FFF;
    text-align: right;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px; /* 100% */
    padding: 13px 24px;
    text-decoration: none;
    border-radius: 40px;
    border: 2px solid #FFF;
    display: inline-block;
  }

  .filter h5 {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 100% */
    text-transform: capitalize;
  }

  .clear_btn {
    color: #EC0101;
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    line-height: 14px; /* 100% */
  }

  .left_bar {
    padding: 20px;
  }
}
@media only screen and (max-width: 991px) {
  .top-margin-product {
    margin-top: 1rem;
  }
}

@media only screen and  (min-width: 768px) and (max-width: 991px) {
  .offcanvas-body {
    background: #F8F8F8;
    box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(328px, 0fr));
    gap: 20px;
    justify-content: space-between;
  }

  .bar_ {
    padding: 20px;
    background: #F8F8F8;
    box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
    gap: 40px;
    display: flex;
    flex-direction: column;
  }

  .img_four {
    display: block !important;
  }

  .product_item_area {
    padding: 20px 40px !important;
  }

  .filter h5 {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 100% */
    text-transform: capitalize;
  }

  .clear_btn {
    color: #EC0101;
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    line-height: 14px; /* 100% */
  }

  .left_bar {
    padding: 20px;
  }


}

@media only screen and  (min-width: 992px) and (max-width: 1199px) {
  .product-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(287px, 0fr));
    gap: 20px;
    justify-content: space-between;
  }


}

@media only screen and  (min-width: 1200px) and (max-width: 1400px) {
  .product-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(230px, 0fr));
    gap: 20px;
    justify-content: space-between;
  }
}

</style>